import React from "react";
import { APP_STORE_URL, PLAY_STORE_URL } from "../utils/constants";

const STORES = [
  { href: PLAY_STORE_URL, icon: "ph-google-play-logo", small: "Get it on", name: "Google Play" },
  { href: APP_STORE_URL, icon: "ph-apple-logo", small: "Download on the", name: "App Store" },
];

/** Google Play and App Store buttons (black badge style). `compact` for narrow spots like the home panel. */
const StoreButtons = ({ compact = false, className = "" }) => (
  <div className={`ui-stores${compact ? " ui-stores--compact" : ""} ${className}`.trim()}>
    {STORES.map(({ href, icon, small, name }) => (
      <a key={name} href={href} className="ui-store" target="_blank" rel="noopener noreferrer">
        <i className={`ph-fill ${icon}`} aria-hidden="true" />
        <span>
          <span className="ui-store__small">{small}</span>
          <span className="ui-store__name">{name}</span>
        </span>
      </a>
    ))}
  </div>
);

export default StoreButtons;
